import React from 'react';
import { CheckoutSettings } from '../../interfaces/checkout_settings';
export const CheckoutContext = React.createContext<CheckoutSettings | null>(
  null,
);
